import { useMutation, useQuery } from 'react-query';
import { ReactQueryKeys } from 'services/api/reactQueryKeys';
import { getMyModelById, togglePublicModel } from 'services/CompanyService';
import i18n, { FALLBACK_LOCALE } from 'providers/i18n/i18n';
import { toast } from 'react-toastify';
import { queryClient } from 'index';
import { getToastErrorMessage, LogyxError } from 'services/api/errors';
import { ReactMutationKeys } from 'services/api/reactMutationKeys';
import { useTranslation } from 'react-i18next';

export const useGetMyModel = (modelId: number) =>
  useQuery({
    queryKey: [
      ReactQueryKeys.GET_MY_MODEL,
      modelId,
      i18n.resolvedLanguage || FALLBACK_LOCALE,
    ],
    queryFn: () => {
      return getMyModelById(modelId);
    },
  });

export interface ITogglePublicModelDTO {
  modelId: number;
  is_public: boolean;
}

export const useTogglePublicModel = () => {
  const { t } = useTranslation();
  return useMutation((dto: ITogglePublicModelDTO) => togglePublicModel(dto), {
    onSuccess: () => {
      toast.success(t('Model public status updated'));
      queryClient.invalidateQueries([ReactQueryKeys.GET_MY_MODEL]);
      queryClient.invalidateQueries([ReactQueryKeys.GET_COMPANIES_FOR_MODEL]);
      queryClient.invalidateQueries([
        ReactQueryKeys.GET_COMPANIES_ELIGIBLE_FOR_MODEL,
      ]);
    },
    onError: (error: LogyxError) => {
      toast.error(getToastErrorMessage(error));
    },
    mutationKey: ReactMutationKeys.TOGGLE_PUBLIC_MODEL,
  });
};
